/**
 * Created by jinm on 2018. 9. 20..
 */
import React, { Component }  from 'react';
import $ from 'jquery';
import ReactTooltip from 'react-tooltip';
import SweetAlert from 'sweetalert-react';
import { Redirect  } from 'react-router-dom';

export default class FunctionBased extends Component {
    constructor(props) {
        super(props);

        this.state = {
            functionList: [{
                keywordOpen: false,
                andOr: "and",
                type: "main",
                searchText: ''
            }],
            functionListProps:{},
            searchOption: [0, 0, 0],
            searchValidationAlert:false,
            redirect: false
        };

    }


    handleAddBtn(rowKey){
        let afterList = this.state.functionList;
        afterList.splice(rowKey+1, 0, {
            keywordOpen: false,
            andOr: "and",
            type: "main",
            searchText: ''
        });
        this.setState({
            functionList: afterList
        })
    }

    handleDuplicateBtn(rowKey){
        let afterList = $.extend(true, [], this.state.functionList);
        afterList.splice(rowKey+1, 0, this.state.functionList[rowKey]);
        this.setState({
            functionList: afterList
        })
    }

    handleDeleteBtn(rowKey){
        let afterList = this.state.functionList;
        afterList.splice(rowKey, 1);
        this.setState({
            functionList: afterList
        })
    }

    componentDidUpdate(){
        if(this.state.functionList.length === 0){
            this.setState({
                functionList: [{
                    keywordOpen: false,
                    andOr: "and",
                    type: "main",
                    searchText: ''
                }]
            })
        }
    }

    handleSearchOption(target, value){
        let searchOption = this.state.searchOption;
        searchOption[target] = (value === true) ? 1 : 0;
        this.setState({
            searchOption: searchOption
        })
    }

    guid() {
        function s4() {
            return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
        }
        return s4() + s4() +  s4();
    }

    renderRedirect = () => {
        if (this.state.redirect) {
            return <Redirect  to={{ pathname: '/result', query: this.state.functionListProps }} />;
        }
    }

    functionBasedSearch() {

        if(this.state.functionList.length===1 && this.state.functionList[0].searchText==='') {
            this.setState({
                searchValidationAlert: true
            })
        } else {
            let propsLow = [];
            let functionRow = this.state.functionList;
            for(let i = 0; i < functionRow.length; i++) {
                if (functionRow[i].searchText === '') continue;
                propsLow.push({'no': i + 1, 'condition': functionRow[i].andOr,'type':functionRow[i].type, 'value':functionRow[i].searchText });
            }
            // console.log('propsLow',propsLow);
            let props = {
                "query" : "",
                "scenario_code" : "PRD",
                "input_component": {
                    "function":propsLow,
                    "component filter":this.state.searchOption,
                    "product_name": [],
                    "filter_common": {
                        "domain": ["Protozoa", "bacteria", "Archaea", "Plantae", "Animalia", "Fungi", "Chromista"],
                        "format_date": 2,
                        "format":1,
                        "usage_rights":2,
                        "language":1
                    },
                }
            };


            this.setState({functionListProps:props});

            this.setState({
                redirect: true
            })



            // return <Redirect  to={{ pathname: '/result', query: { the: 'query' } }} />

        }
    }

    clearForm() {
        this.setState({functionList: [{
                keywordOpen: false,
                andOr: "and",
                type: "main",
                searchText: ''
            }]});
    }

    render() {



        let functionBasedRow = [];

        // console.log(this.state.functionList);

        this.state.functionList.map((row, key) => {
            //let unique = String(Math.floor(new Date().getTime())) + String(key);
            let unique = this.guid();
            functionBasedRow.push(<li key={unique}>
                <FunctionBasedRow
                    data={row}
                    key={unique}
                    rowKey={key}
                    handleAddBtn={rowKey => this.handleAddBtn(rowKey)}
                    handleDuplicateBtn={rowKey => this.handleDuplicateBtn(rowKey)}
                    handleDeleteBtn={rowKey => this.handleDeleteBtn(rowKey)}
                />
            </li>);
        });

        return (
            <div className="scenarioBox boxInput">
                {this.renderRedirect()}
                <SweetAlert
                    show={this.state.searchValidationAlert}
                    title="Not able to search"
                    text="You must fill in one search bar at least."
                    onConfirm={() => {this.setState({ searchValidationAlert: false })}}
                />
                <ul id="productFunctionWrap">
                    {functionBasedRow}
                </ul>
                <ul className="scenarioChk chkLabel">
                    <li>
                        <input type="checkbox" onChange={event => this.handleSearchOption(0, event.target.checked)}
                               checked={this.state.searchOption[0] === 1} id="searchOption1"/>
                        <label htmlFor="searchOption1">Search with the exact product function</label>
                    </li>
                    <li>
                        <input type="checkbox" onChange={event => this.handleSearchOption(1, event.target.checked)}
                               checked={this.state.searchOption[1] === 1} id="searchOption2"/>
                        <label htmlFor="searchOption2">Search without the function verbs</label>
                    </li>
                    <li>
                        <input type="checkbox" onChange={event => this.handleSearchOption(2, event.target.checked)}
                               checked={this.state.searchOption[2] === 1} id="searchOption3"/>
                        <label htmlFor="searchOption3">Search all of the related products</label>
                    </li>
                </ul>
                <div className="submitBox">
                    <button className="clear" onClick={this.clearForm.bind(this)}>Clear Form</button>
                    <button className="submit"
                            onClick={this.functionBasedSearch.bind(this)}>Search</button>
                </div>
            </div>
        );
    }
}


class FunctionBasedRow extends Component {
    constructor(props) {
        super(props);

        this.state = {
            keywordOpen: this.props.data.keywordOpen,
            andOr: this.props.data.andOr,
            type: this.props.data.type,
            searchText: this.props.data.searchText,
        }
    }

    keywordWarpHandle(isOpen){
        this.props.data.keywordOpen = isOpen;
        this.setState({
            keywordOpen: isOpen
        });
    }

    handleAndOrChange(event) {
        this.props.data.andOr = event.target.value;
        this.setState({
            andOr: event.target.value
        });
    }

    handleTypeChange(event) {
        this.props.data.type = event.target.value;
        this.setState({
            type: event.target.value
        });
    }

    searchTextHandle(searchText) {
        this.props.data.searchText = searchText;
        this.setState({
            searchText: searchText
        });
    }

    render() {

        let keywordWrap = <Keyword
            keywordWarpHandle={isOpen => this.keywordWarpHandle(isOpen)}
            searchTextHandle={searchText => this.searchTextHandle(searchText)}
        />;
        if(!this.state.keywordOpen)
            keywordWrap = null;

        return (
            <div>

                <input
                    id={this.props.rowKey + 'and'}
                    type="radio"
                    value="and"
                    checked={this.state.andOr === "and"}
                    onChange={event => this.handleAndOrChange(event)}
                />
                <label htmlFor={this.props.rowKey + 'and'}>AND</label>

                <input
                    id={this.props.rowKey + 'or'}
                    type="radio"
                    value="or"
                    checked={this.state.andOr === "or"}
                    onChange={event => this.handleAndOrChange(event)}
                />
                <label htmlFor={this.props.rowKey + 'or'}>OR</label>

                <select
                    value={this.state.type}
                    onChange={event => this.handleTypeChange(event)}>
                    <option value="main">Main Function
                    </option>
                    <option value="sub">sub Function
                    </option>
                </select>

                <input type="text" readOnly={true} style={{ cursor: "pointer" }}
                       placeholder="Click to choose a verb and a noun"
                       onClick={() => this.keywordWarpHandle(true)}
                       value={this.state.searchText}
                />
                <ReactTooltip id='duplicate' place="bottom" type="light" effect="float">
                    <span>duplicate</span>
                </ReactTooltip>
                <button onClick={() => this.props.handleDuplicateBtn(this.props.rowKey)}
                        data-tip data-for='duplicate'>
                    <i className="far fa-clone"></i>
                </button>
                <ReactTooltip id='add' place="bottom" type="light" effect="float">
                    <span>add</span>
                </ReactTooltip>
                <button onClick={() => this.props.handleAddBtn(this.props.rowKey)}
                        data-tip data-for='add'>
                    <i className="fas fa-plus-circle"></i>
                </button>
                <ReactTooltip id='delete' place="bottom" type="light" effect="float">
                    <span>delete</span>
                </ReactTooltip>
                <button onClick={() => this.props.handleDeleteBtn(this.props.rowKey)}
                        data-tip data-for='delete'>
                    <i className="far fa-times-circle"></i>
                </button>
                {keywordWrap}

            </div>
        );
    }
}


class Keyword extends Component {
    constructor(props) {
        super(props);

        this.state = {
            action: "Absorb",
            object: "Divided Solid"
        };

        this.keywords = require('./keyword.json');
    }

    handleActionChange(event) {
        this.setState({
            action: event.target.value
        });
    }

    handleObjectChange(event) {
        this.setState({
            object: event.target.value
        });
    }

    render() {

        let actionList = this.keywords.action.map((action, key) => {
            return <li key={key} className="chkLabel">
                <input
                    id={action}
                    name="action"
                    type="radio"
                    value={action}
                    checked={this.state.action === action}
                    onChange={event => this.handleActionChange(event)}
                />
                <label htmlFor={action}>{action}</label>
            </li>;
        });

        let objectList = this.keywords.object.map((object, key) => {
            return <li key={key} className="chkLabel">
                <input
                    id={object}
                    name="object"
                    type="radio"
                    value={object}
                    checked={this.state.object === object}
                    onChange={event => this.handleObjectChange(event)}
                />
                <label htmlFor={object}>{object}</label>
            </li>;
        });

        return (
            <div className="overlay">
                <div className="functionBasedPopup">
                    <div className="step1">
                        <h3>1. Choose an Action</h3>
                        <div>
                            <ul>{actionList}</ul>
                        </div>
                    </div>
                    <div className="step2">
                        <h3>2. and an Object</h3>
                        <div>
                            <ul>{objectList}</ul>
                        </div>
                    </div>
                    <div className="submitBox">
                        <button
                            onClick={() => this.props.keywordWarpHandle(false)} className="clear"
                        >
                            Cancel
                        </button>
                        <button className="submit"
                            onClick={() => {
                                this.props.searchTextHandle(this.state.action+" "+this.state.object);
                                this.props.keywordWarpHandle(false);
                            }}
                        >
                            Complete
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/FunctionBased.js